import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import Logo from "@/components/store/Logo";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "", phone: "", street: "", unit: "", city: "", state: "", zip: "", country: "", newsletter: true });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register({
        name: f.name, email: f.email, password: f.password, phone: f.phone, newsletter: f.newsletter,
        address: { street: f.street, unit: f.unit, city: f.city, state: f.state, zip: f.zip, country: f.country },
      });
      navigate("/account");
    } catch (err) { setError(apiErr(err)); }
    setLoading(false);
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16" data-testid="register-page">
      <div className="w-full max-w-lg">
        <div className="text-center mb-8"><Logo /></div>
        <h1 className="font-heading text-4xl tracking-tight text-center mb-2">Create Your Account</h1>
        <p className="font-body text-sm text-ink/60 text-center mb-8">Save your details for a smoother voyage.</p>
        {error && <p className="text-sm text-destructive text-center mb-4 font-body" data-testid="register-error">{error}</p>}
        <form onSubmit={submit} className="grid grid-cols-2 gap-x-5 gap-y-5">
          <input data-testid="register-name-input" className="input-luxe col-span-2" placeholder="Full Name" value={f.name} onChange={set("name")} required />
          <input data-testid="register-email-input" className="input-luxe" type="email" placeholder="Email" value={f.email} onChange={set("email")} required />
          <input data-testid="register-phone-input" className="input-luxe" placeholder="Phone" value={f.phone} onChange={set("phone")} />
          <input data-testid="register-password-input" className="input-luxe col-span-2" type="password" placeholder="Password" value={f.password} onChange={set("password")} required />
          <input className="input-luxe col-span-2" placeholder="Street Address" value={f.street} onChange={set("street")} />
          <input className="input-luxe" placeholder="Unit / Suite" value={f.unit} onChange={set("unit")} />
          <input className="input-luxe" placeholder="City" value={f.city} onChange={set("city")} />
          <input className="input-luxe" placeholder="State / Province" value={f.state} onChange={set("state")} />
          <input className="input-luxe" placeholder="ZIP / Postal" value={f.zip} onChange={set("zip")} />
          <input className="input-luxe col-span-2" placeholder="Country" value={f.country} onChange={set("country")} />
          <label className="col-span-2 flex items-center gap-3 font-body text-sm text-ink/70 mt-2">
            <input type="checkbox" data-testid="register-newsletter" checked={f.newsletter} onChange={set("newsletter")} className="accent-ink w-4 h-4" />
            Subscribe to new drops & stories from the voyage
          </label>
          <button data-testid="register-submit-button" className="btn-primary w-full col-span-2 mt-2" disabled={loading}>{loading ? "Creating…" : "Create Account"}</button>
        </form>
        <p className="font-body text-sm text-ink/60 text-center mt-6">Already have an account? <Link to="/login" data-testid="register-login-link" className="underline hover:text-ink">Sign in</Link></p>
      </div>
    </div>
  );
}
